import $ from 'zepto';
import { validations } from './validations';
import { getRowItemConfig } from './itemConfig';
import {
  assert,
  isQueryCollection,
  getNewId,
  log,
} from '../../utils';
import { DATA_ELEMENT_ID } from '../../utils/constants/dataKeys';
import {
  formRowSelector,
  itemFooterMessageSelector,
  itemFooterMessageClass,
  fontCopyClass,
  fontCopyErrorClass,
  iconfontCopyErrorClass,
} from '../../utils/constants/classes';
import {
  appendAndSlideDown,
  prependAndSlideDown,
  slideUpAndRemove,
} from '../../utils/dom';

export const DEFAULT_DURATION = 400;

export const appendFooterMessage = ($footerMessage, $message, onComplete) => appendAndSlideDown({
  $element: $message,
  $parent: $footerMessage,
  onComplete,
  duration: DEFAULT_DURATION,
});

export const prependFooterMessage = ($footerMessage, $message, onComplete) => prependAndSlideDown({
  $element: $message,
  $parent: $footerMessage,
  onComplete,
  duration: DEFAULT_DURATION,
});

export const removeAllFooterMessages = ($footerMessage, onComplete) => slideUpAndRemove({
  $element: $footerMessage,
  onComplete,
  duration: DEFAULT_DURATION,
});

export const removeFirstFooterMessage = ($footerMessage, onComplete) => {
  const $message = $footerMessage
    .children()
    .first();

  return slideUpAndRemove({
    $element: $message,
    onComplete,
    duration: DEFAULT_DURATION,
  });
};

export const removeLastFooterMessage = ($footerMessage, onComplete) => {
  const $message = $footerMessage
    .children()
    .last();

  return slideUpAndRemove({
    $element: $message,
    onComplete,
    duration: DEFAULT_DURATION,
  });
};

export const removeUselessFooterMessageContainer = ($footerMessage) => {
  if ($footerMessage.children().length === 0) {
    $footerMessage.remove();
  }
};

export const getFieldRow = (field) => field.$field.closest(formRowSelector);

export const createFooterMessage = () => $('<div/>', {
  class: itemFooterMessageClass,
});

export const getFooterMessage = ($row) => {
  let $footerMessage = $row.find(itemFooterMessageSelector);
  if ($footerMessage.length === 0) {
    $footerMessage = createFooterMessage();
    $row.append($footerMessage);
  }

  return $footerMessage;
};

export const createMessage = (options) => {
  assert(options && options.text, '`options.text` is required');

  const { text, isError = false } = options;
  if (isError) {
    return $('<p/>', {
      class: `${fontCopyErrorClass} ${iconfontCopyErrorClass}`,
      text,
    });
  }
  // NOTE: this is not the correct message (info) style
  // because it is not implemented yet in xvx.
  return $('<p/>', {
    class: fontCopyClass,
    text,
  });
};

export const getMessageFromOptions = ({ message, isError }) => {
  if (typeof message === 'string') {
    return createMessage({ text: message, isError });
  }

  if (!isQueryCollection(message)) {
    assert(undefined, '`options.message` is not a query collection');
  }
  return message;
};

export const getFormId = ($form) => {
  const id = $form.attr('id') || $form.data(DATA_ELEMENT_ID);

  if (id) {
    return id;
  }

  const newId = getNewId();
  $form.data(DATA_ELEMENT_ID, newId);

  return newId;
};

const tryValidation = (item, config) => {
  try {
    const { name, test } = config;
    if ($.isFunction(test)) {
      return test(item);
    }

    const validation = validations[name];
    return validation(item, config);
  } catch (error) {
    log.error(error.message);
    // NOTE: in order to avoid getting the user stock in a form
    // because of a 'throwable' validation, the validations that throw an error
    // are going to be considered as passed so the request can get to the server
    // and have a proper (I hope) handling.
    return true;
  }
};

export const checkRowItemValue = (item) => {
  const { id } = item;
  const { validations: configs } = getRowItemConfig(id);

  const failedConfig = configs.find((config) => !tryValidation(item, config));

  if (failedConfig) {
    const { message } = failedConfig;
    return {
      isValid: false,
      message,
    };
  }

  return {
    isValid: true,
  };
};
